module.exports = __webpack_public_path__ + "static/media/lucas_0.04b99b6f.png";